// extracted by mini-css-extract-plugin
export default {"banner":"vqsdn","image":"ClaoN","container":"v9FpG","title":"dj5Z1","promocode":"Kadp8","subtitle":"o49hI"};